import { Injectable, ViewContainerRef } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IToolbarAction } from '../model/toolbar-action';

@Injectable({
  providedIn: 'root'
})
export class ToolbarService {

  public toolbarConfiguration$: BehaviorSubject<IToolbarAction[] | null> =
    new BehaviorSubject<IToolbarAction[] | null>(null);

  public actionEmitter$: Subject<{ id: string, fn: any, cb: (act) => void }> =
    new Subject<{ id: string, fn: any, cb: (act) => void }>();


  public getToolbarConfiguration(): IToolbarAction[] {
    return this.toolbarConfiguration$.value;
  }

  public setToolbarConfiguration(config: IToolbarAction[]) {
    this.toolbarConfiguration$.next(config);
  }

  public emitAction(act: any) {
    this.actionEmitter$.next(act);
  }

}
